<sb-dialog-activation
  [showTitle]="true"
  [asidePanelAlwaysVisible]="true"
  [flowOrder]="DialogActivationFlowOrder.ASIDE_PANEL_FIRST"
>
  <div main-panel>
    <chapter-step
      [title]="'Run your business from anywhere' | translate"
      [nextButtonLabel]="'Done!' | translate"
      (next)="close({ action: 'primary' })"
    >
      <div class="flex flex-col gap-1">
        <chapter-item [text]="'View and edit schedules' | translate" />
        <chapter-item [text]="'Track hours worked and availability' | translate" />
        <chapter-item [text]="'Approve absences and shift exchanges' | translate" />
        <chapter-item [text]="'Get insights into your business performance' | translate" />
      </div>
    </chapter-step>
  </div>
  <div
    class="flex size-full max-h-72 items-center justify-center overflow-hidden rounded-lg bg-brand-subtle p-6 lg:mr-12 lg:max-h-inherit lg:p-8"
    aside-panel
  >
    <div
      class="flex h-full w-48 flex-col items-center overflow-hidden rounded-xl bg-surface-page p-4 text-default lg:h-auto lg:w-full"
    >
      <img [src]="qrCodeImagePath" alt="Mobile App QR Code" class="size-full object-contain" />
      <h3 class="shrink-0 py-3 uppercase">{{ 'Scan code' | translate }}</h3>
    </div>
  </div>
</sb-dialog-activation>
